import { h } from 'preact'
import { Modal } from './Modal'
import { ModalHeader } from './ModalHeader'
import { ModalBody } from './ModalBody'
import { ModalFooter } from './ModalFooter'
import ButtonControl from '../button-control'

interface Props {
  isOpen: boolean
  handleConfirmation: () => void
  onClose: () => void
  title: string
  body: string
  action: string
  variant: string
}

const ConfirmationModal = (
  { isOpen, handleConfirmation, onClose, title, body, action, variant }: Props) => {
  return (
    <Modal isOpen={isOpen} size='medium'>
      <ModalHeader title={title} onClose={onClose} />
      <ModalBody>
        <p>{body}</p>
      </ModalBody>
      <ModalFooter>
        <ButtonControl
          title={action}
          variant={variant}
          onClick={handleConfirmation}
          newStyle
          size='medium'
        />
        <ButtonControl
          title='Cancel'
          onClick={onClose}
          newStyle
          size='medium'
        />
      </ModalFooter>
    </Modal>
  )
}

export default ConfirmationModal
